import gql from "graphql-tag";

export const CHANGE_CREDIT_CARD_MUTATION = gql`
  mutation ChangeCreditCard($input: CreditCardInput!) {
    changeCreditCard(input: $input)
  }
`;
